import React, { useContext, useMemo } from 'react'
import appContext from '../../Context/appContext';
import { Highlight, useHits } from 'react-instantsearch-hooks-web';
import { getBrands } from '../../helpers/search';
import LoadImage from '../LoadImage';
import Link from 'next/dist/client/link';
import { useSelector } from 'react-redux';

const SearchBrands = ({ currentTab: tab }) => {
  // const {
  //   state: {
  //     search: {
  //       searchQuery
  //     }
  //   }
  // } = useContext(appContext)

  const searchQuery = useSelector(state => state.search.searchQuery)


  const { hits } = useHits({});
  const brands = useMemo(() => {
    return getBrands({ hits, searchQuery })
  }, [hits, searchQuery]);

  return (
    brands.length ? <>
      <div className="mb-5">
        <div className="search-tab-title mb-4">
          {brands.length > 1 ? `Brands (${brands?.length})` : 'Brand (1)'}
        </div>
        <div className="search-brand">
          {
            brands.map((item) => (
              item?.brand_image_url ?
                <Link
                  key={item?.product_detail_id}
                  prefetch={false}
                  href={{ pathname: '/brands/[slug]', query: tab && { tab } }}
                  as={{ pathname: `/brands/${item?.brands_with_links?.[0]}`, query: tab && { tab } }}
                >
                  <div className="single-brand">
                    <LoadImage src={item?.brand_image_url} height={60} width={60} alt={item?.brand_image_url} />
                    <div className="title"><Highlight attribute='custom_brand' hit={item} /></div>
                    <i className="icon-chevron-right-f" />
                  </div>

                </Link>
                : null
            ))
          }
        </div>
      </div>
    </>
      : null
  )
}

export default SearchBrands